import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  logoContainer: {
    marginTop: 5,
    marginRight: 32,
    marginLeft: 14,
  },
}));

export default useStyles;
